/** The index bar, in both the places it is shown: the first index takes the pane, every one after it is a
 *  hairline under the header. One bar for the whole run — reading the sheets and understanding them used to
 *  fill one each, so it ran to the end, snapped back to zero and ran again.
 *
 *  No animation beyond the width easing into place: a sheen over the fill and a sliding stretch for the
 *  indeterminate case were both tried and both read as noise in a pane this narrow. */
export function ProgressBar({ fraction, thin = false }: { fraction: number | null; thin?: boolean }) {
  const height = thin ? 'h-1' : 'h-1.5';
  const percent = fraction === null ? 0 : Math.round(Math.min(1, Math.max(0, fraction)) * 100);
  return (
    <div className={`w-full overflow-hidden rounded-sm bg-line-soft ${height}`} role="presentation">
      <div className={`rounded-sm bg-accent transition-[width] duration-500 ease-out ${height}`} style={{ width: `${percent}%` }} />
    </div>
  );
}
